import React, { useState } from 'react';
import Layout from "../components/App/Layout";
import Navbar from "../components/App/Navbar";
import PageBanner from '../components/Common/PageBanner';
import Footer from "../components/App/Footer";
import SEO from "../components/App/SEO";
import banner_image from '../assets/images/banner_image.jpg';
import b4 from '../assets/images/b4.jpg';
import ai_banner3 from '../assets/images/ai_banner3.jpg';
import a1 from '../assets/images/a1.jpg';
import a2 from '../assets/images/a2.jpg';
import a3 from '../assets/images/a3.jpg';
import i1 from '../assets/images/i1.png';
import i3 from '../assets/images/i3.png';
import i4 from '../assets/images/i4.png';
import i2 from '../assets/images/i2.png';
// Add these imports at the top with other image imports
import step1_icon from '../assets/images/step1.png';
import step2_icon from '../assets/images/step2.png';
import step3_icon from '../assets/images/step3.png';
import step4_icon from '../assets/images/step4.png';
import step5_icon from '../assets/images/step5.png'
import step6_icon from '../assets/images/step6_icon.png'
import Agriculture from '../assets/images/Agriculture.png';
import Automotive from '../assets/images/Automotive.png';
import Education from '../assets/images/Education.png';
import Finance from '../assets/images/Finance.png';
import real_estate from '../assets/images/real_estate.png';
import technology from '../assets/images/technology.png';
import Government_public_sector from '../assets/images/Government_public_sector.png';
import Healthcare from '../assets/images/Healthcare.png';
import Logistics from '../assets/images/Logistics.png';
import Manufacturing from '../assets/images/Manufacturing.png';
import Media from '../assets/images/Media.png';
import Retail from '../assets/images/Retail.png';
import Swal from 'sweetalert2';
import consistent from '../assets/images/consistent.png';
import phonecall from '../assets/images/phonecall.png';
import FunfactComponent from "../components/DynamicPages/FunfactComponent"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
const sendEmail = async (e) => {
  e.preventDefault()
  // alert('sent successfully');

  const messageBody = `

  Hi,
  
  Name: ${e.target.elements.name.value}
  Phone No: ${e.target.elements.email.value}
  Message: ${e.target.elements.message.value}
  technology:${e.target.elements.technology.value}
  `
  console.log(messageBody);
  try {

    const response = await fetch('https://p8t29dandg.execute-api.ap-south-1.amazonaws.com/prod', {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "no-cors", // no-cors, cors, *same-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: e.target.elements.email.value, messageBody },), // body data type must match "Content-Type" header
    }).then(() => Swal.fire(
      'Mail Sent Successfully!',

    )
    )
    window.location.reload(false);
    ;
    // const json = await response.json()

  } catch (error) {
    console.log(error);
  }
}
const services = [
  {
    title: "UX Design (User Experience)",
    text: "Focuses on the overall experience a user has while interacting with a product or service. It's about making the product.",
    topics: [
      "<b>Usable:</b> Easy to learn and navigate.",
      "<b>Useful</b>: Fulfilling user needs and goals.",
      "<b>Desirable</b>: Engaging and enjoyable to use.",
      "<b>Findable</b>: Easy for users to locate what they need.",
      "<b>Accessible</b>: Designed for users with a wide range of abilities.",
      "<b>Credible</b>: Trustworthy and reliable."
    ],
    icon: i1,
  },
  {
    title: "UI Design (User Interface)",
    text: "Focuses on the visual elements and interactive components of a digital product. It's about how the product looks and how users interact with specific elements like buttons, icons, typography, colors, and overall layout. The goal is to create interfaces that are",
    topics: [
      "<b>Visually appealing.</b>",
      "<b>Intuitive and easy to understand.</b>",
      "<b>Consistent with branding.</b>",
      "<b>Responsive across different devices.</b>"
    ],
    icon: i2,
  },
  {
    title: "UI/UX Designing Services Typically Include",
    text: "A company offering UI/UX design services will help you create digital products that are both effective and enjoyable for your users. Their services often encompass",
    topics: [
      "<b>User Research:</b> Understanding your target audience, their needs, behaviors, and goals through methods like interviews, surveys, and usability testing.",
      "<b>User Personas & Journey Mapping:</b> Creating representations of your ideal users and visualizing their interactions with your product.",
      "<b>Information Architecture:</b> Structuring and organizing content in a logical and intuitive way.",
      "<b>Wireframing & Prototyping:</b> Creating low-fidelity (wireframes) and high-fidelity (prototypes) mockups to visualize the user flow and interface elements.",
      "<b>Visual Design (UI Design):</b> Developing the aesthetic look and feel of the interface, including branding elements, color palettes, typography, and imagery.",
      "<b>Usability Testing:</b> Evaluating the design with real users to identify pain points and areas for improvement.",
      "<b>UI/UX Consulting:</b> Providing expert advice and guidance on your design strategy and challenges."
    ],
    icon: i3,
  },
  {
    title: "Benefits of Investing in UI/UX Design Services",
    text: "Integrate powerful generative AI models seamlessly into your existing systems with help from our experienced team.",
    topics: [
      "<b>User Research:</b> Understanding your target audience, their needs, behaviors, and goals through methods like interviews, surveys, and usability testing.",
      "<b>Increased Conversion Rates:</b> Intuitive and user-friendly interfaces guide users towards desired actions.", "<b>Improved Brand Loyalty and Trust:</b> A well-designed product reflects professionalism & builds confidence in your brand.",
      "<b>Reduced Development Costs:</b> Identifying and fixing usability issues early in the design process is less expensive than making changes after development.", "<b>Competitive Advantage:</b> A superior user experience can differentiate your product in a crowded market.",
      "<b>Better ROI (Return on Investment):</b> Studies have shown that investing in UX design can yield significant returns.", "<b>Increased Customer Retention:</b> Users are more likely to return to a product or service they find enjoyable & easy to use.", "<b>Improved Website Speed:</b> Efficient design can contribute to faster loading times.", "Better Accessibility: Ensures your product can be used by a wider audience.",
    ],
    icon: i4,
  },
];

const industries = [
  {
    title: "Technology & SaaS",
    icon: technology,
  },
  {
    title: "Finance & FinTech",
    icon: Finance,
  },
  {
    title: "Healthcare & MedTech",
    icon: Healthcare,
  },
  {
    title: "E-Commerce & Retail",
    icon: Retail,
  },
  {
    title: "Manufacturing & Industry 4.0",
    icon: Manufacturing,
  },
  {
    title: "Media & Entertainment",
    icon: Media,
  },
  {
    title: "Travel & Hospitality",
    icon: Automotive,
  },
  {
    title: "Real Estate & PropTech",
    icon: real_estate,
  },
  {
    title: "Agriculture (AgriTech)",
    icon: Agriculture,
  },
  {
    title: "Logistics & Supply Chain",
    icon: Logistics,
  },
  {
    title: "EdTech & E-Learning",
    icon: Education,
  },
  {
    title: "Government & Public Sector",
    icon: Government_public_sector,
  },

];

// Update the executionSteps array to include icons
const executionSteps = [
  { text: "Project Initiation & Goal Defination", icon: step1_icon },
  { text: "Planning & Strategy", icon: step2_icon },
  { text: "Execution & Task Management", icon: step3_icon },
  { text: "Monitoring Control", icon: step4_icon },
  { text: "Quality Assurance & Testing", icon: step5_icon },
  { text: "Closure & Review", icon: step6_icon }
];

const faqData = [
  {
    question: 'What’s the difference between UI and UX design?',
    answer: 'We offer services like natural language processing, machine learning model development, computer vision, AI consulting, and custom AI solution development.',
  },
  {
    question: 'Why is UI/UX design important for my business?',
    answer: 'AI can streamline operations, improve customer service, provide predictive analytics, and automate routine tasks, increasing overall efficiency and innovation.',
  },
  {
    question: 'How long does a UI/UX design project take?',
    answer: 'We specialize in healthcare, finance, e-commerce, manufacturing, and logistics, among other industries.',
  },
];

const IotDevelopment = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Layout>
      <SEO
        title="UI/UX Design Services | User Experience & Interface Design | SrashtaSoft"
        description="SrashtaSoft offers expert UI/UX design services to build interfaces users love. Hire our designers for user research, wireframing, prototyping, and visual design solutions."
        canonical="https://srashtasoft.com/ui-ux-development/"
        isServicePage
        serviceName="UI/UX Design Services"
        faqData={faqData}
      />
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section" style={{
        background: `url(${banner_image}) no-repeat center center/cover`,
        height: "500px",
        color: "white",
        display: "flex",
        alignItems: "center"
      }}>
        <div className="bg-overlay d-flex align-items-center w-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <h2 className="fw-bold">
                  Designing the Future < br />
                  of Interaction
                </h2>
                <p className="mt-3 text-white">
                  Where AI Meets Intuitive Design – Crafting Seamless Digital < br />
                  Experiences Powered by Intelligence.
                </p>
                <a href="/contact-us/" className="btn btn-custom mt-4">Let’s talk Now!</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6">
              <h2 className="h1 fw-bold text-headings mb-4">
                Build Interfaces Users Love & < br />
                Technology Understands
              </h2>
              <p className="text-secondary mb-3">
                We are a team of passionate designers, researchers, and < br /> technologists who believe that exceptional digital experiences happen < br /> at the intersection of empathy and innovation. Our mission? To build < br /> interfaces that users genuinely love and technology seamlessly < br /> supports—blending human needs with intelligent design.
              </p>
              <p className="text-secondary mb-4">
                We don’t just make things look good—we design for real behavior,< br /> emotions, and needs. Through deep user research, psychology-driven< br /> design, and continuous testing, we craft experiences that feel intuitive,< br /> inclusive, and delightful.
              </p>
              <p className="text-secondary mb-4">
                Great UX isn’t just about aesthetics—it’s about what’s possible. We< br /> collaborate closely with developers and engineers to ensure our< br /> designs
              </p>
              <a href="/contact-us" className="btn btn-white px-4 py-2" style={{
                color: "#1A2B5F",
                border: "0.6px solid #1A2B5F",
                textDecoration: "none" // optional, to remove underline
              }}>
                Let’s talk UI/UX Design Project
              </a>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-6">
                  <img src={a1} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 1" />
                </div>
                <div className="col-6">
                  <img src={a2} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 2" />
                </div>
                <div className="col-12 pt-4">
                  <img src={a3} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Banner CTA */}
      <section className="py-5 text-white position-relative" style={{
        background: `url(${b4}) no-repeat center center/cover`,
        height: "350px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#007bff40",
          zIndex: 1
        }}></div>

        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start" style={{ position: "relative", zIndex: 2 }}>
          <h2 className="h3 fw-bold mb-4 mb-md-0" style={{ fontSize: "46px" }}>
            We've designed award-winning <br />
            experiences that users love & <br />
            technology understands.
          </h2>
          <a href="/contact-us/" className="btn btn-light fw-semibold text-dark" style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "2%",
            width: "180PX",
            height: "56",
            borderRadius: "6px"
          }}>
            Let’s talk Now!
          </a>
        </div>
      </section>

      {/* Services */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-5 fw-bold text-center" style={{ color: "#1A2B5F", fontSize: "40px" }}>UI/UX Designing Services</h2>
          <div className="row g-4">
            {services.map((service, index) => (
              <div className="col-md-6 col-lg-6" key={index} style={{ marginTop: "30px" }}>
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <img src={service.icon} loading="lazy" className="mb-3" alt={service.title} />
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text text-muted">{service.text}</p>
                    {service.topics && (
                      <ul className="list-unstyled mt-3">
                        {service.topics.map((topic, topicIndex) => (
                          <li key={topicIndex} className="mb-2" style={{
                            display: 'flex',
                            alignItems: 'flex-start'
                          }}>
                            <span dangerouslySetInnerHTML={{ __html: topic }} />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h2 className="fw-bold mb-4" style={{ color: "#1A2B5F" }}>Industries We Serve</h2>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 g-4">
            {industries.map((industry, index) => (
              <div className="col" key={index} style={{
                height: "160px !important",
                marginTop: "24px"
              }}>
                <div className="p-4 shadow-sm h-100 text-center" style={{ borderRadius: "12px", border: "1px solid #E3E3E3" }}>
                  <img
                    src={industry.icon}
                    alt={industry.title}
                    className="mb-3"
                    loading="lazy"
                    style={{ width: "50px", height: "50px", objectFit: "contain" }}
                  />
                  <h5 className="fw-semibold font_size mb-2">{industry.title}</h5>
                  <p className="text-muted small mb-0">{industry.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Execution Steps */}
      <section
        className="text-white py-5"
        style={{
          backgroundImage: `url(${ai_banner3})`,
          backgroundColor: "#296bdbd1", // Base layer for blending
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundBlendMode: "overlay",
          height: "660px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="container text-center"
          style={{ height: "663px", alignContent: "center" }}
        >
          <h2
            className="fw-bold mb-5"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "40px",
              letterSpacing: "2%",
              textAlign: "center",
              textTransform: "capitalize",
            }}
          >
            How We Execute Your Project
          </h2>

          <div className="row justify-content-center gy-4" style={{ height: "313px" }}>
            {executionSteps.map((step, index) => (
              <div
                className="col-6 col-sm-4 col-md-2"
                key={index}
                style={index % 2 !== 0 ? { marginTop: "70px" } : {}}
              >
                <div className="d-flex flex-column align-items-center">
                  <img
                    src={step.icon}
                    alt={step.text}
                    className="mb-3"
                    style={{
                      width: "155px",
                      height: "155px",
                      objectFit: "contain",
                    }}
                  />
                  <p
                    className="fw-semibold small text-white mb-0"
                    style={{
                      fontWeight: 700,
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "4%",
                      textAlign: "center",
                      verticalAlign: "middle",
                      textTransform: "capitalize",
                    }}
                  >
                    {step.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* FAQ */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="text-center fw-bold mb-4"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textTransform: "capitalize",
            }}
          >
            FAQs: UI/UX Design Services
          </h2>

          <div className="panel-group wrap" id="bs-collapse">

            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What’s the difference between UI and UX design?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    UI (User Interface) design refers to the visual aspects of a product that users interact with. It focuses on the layout, colors, fonts, buttons, and overall aesthetic elements that make a product engaging and easy to use.
                  </p>
                  <p>
                    UX (User Experience) design is about the overall experience a user has when interacting with a product. It involves understanding user behavior, needs, and pain points to create intuitive and efficient interfaces. While UI is focused on how things look, UX is about how things work.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Why is UI/UX design important for my business?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    UI/UX design is essential because it directly impacts how users interact with your product. A well-designed user interface and experience can lead to:
                  </p>
                  <ul>
                    <li>Increased customer satisfaction: A seamless, enjoyable experience encourages users to return.</li>
                    <li>Higher conversion rates: Intuitive and user-friendly designs make it easier for users to complete desired actions.</li>
                    <li>Stronger brand perception: A professional, easy-to-use design enhances trust in your brand.</li>
                    <li>Reduced development costs: Solving usability issues early in the design phase can prevent expensive changes later in development.</li>
                  </ul>
                  <p>Good UI/UX design ultimately helps you create a product that not only works well but also delights your customers, boosting engagement and retention.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How long does a UI/UX design project take?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    The timeline for a UI/UX design project depends on the complexity and scope of the product. Generally, a project can take anywhere from 2 weeks to several months depending on the following factors:
                  </p>
                  <ul>
                    <li>Project size and complexity: More intricate designs or larger projects require more time.</li>
                    <li>Research and user testing: Projects involving extensive user research, feedback collection, and testing tend to take longer.
                    </li>
                    <li>Number of revisions: The more feedback and iterations are involved, the longer the timeline.</li>
                  </ul>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
      <FunfactComponent />
      <section className='need-help-section' id='need-help'>
        <div className='container'>
          <div className='row quote-formss'>
            <div className='col-lg-6 col-md-12'>
              <h1>NEED HELP ?</h1>
              <p className='need-paragraph'>Choosing The Right Package</p>
              <div className='row padding-class'>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={consistent} />
                    </div>
                    <p className='normal-p'>	Contact a <strong class="yello-colors"> UI/UX Development</strong></p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={phonecall} />
                    </div>
                    <p className='normal-p'>	<a classname="ancher-link" href="tel:+(91) 9898582705">Schedule <strong class="yello-colors"> a call with us  </strong></a></p>
                  </div>
                </div>

              </div>
              <span className='heading-text'>+(91) 9898582705</span>
            </div>
            <div className='col-lg-2 col-md-0'></div>
            <div className='col-lg-4 col-md-12'>
              <section id="quote" className="bg-msar msar-quote-form">
                <section className="row">
                  <form onSubmit={sendEmail}>

                    <div className="col-md-12">
                      <div className="mt-4 white-text">Get Your Free</div>
                      <h4 className='white-text'>Consultation &amp; Quote</h4>
                      <div id="frm-quote">
                        <div className="form-group mt-4">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Name*"
                            name="name"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Email*"
                            name="email"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <select class="form-control w-100 border-0 p-2 " name='technology'
                          //  onChange={onInputchange}
                          >
                            <option value="Service">Service Required </option>
                            <option value="ReactJs">ReactJs Development</option>
                            <option value="NodeJs">NodeJs Developement</option>
                            <option value="WordPress">WordPress Development</option>
                            <option value="PHP">PHP Development</option>
                            <option value="Laravel">Laravel Development</option>
                            <option value="Flutter">Flutter Development</option>
                            <option value="Reactnative">React Native Development</option>
                            <option value="Android">Android Development</option>
                            <option value="IOS">IOS Development</option>
                            <option value="graIOTpefruit">IOT Development</option>
                            <option value="UIUX">UI/UX Development</option>
                            <option value="Shopify">Shopify Development</option>
                            <option value="Magento">Magento Development</option>
                            <option value="Layout">Layout Design</option>
                            <option value="Html">Html Development</option>
                            <option value="Logo">Logo Design</option>
                            <option value="Python">Python Development</option>
                          </select>
                        </div>

                        <div className="form-group mb-0">
                          <textarea className="form-group w-100 border-0 p-2 mb-0"
                            rows="2"
                            placeholder="Your Text"
                            // onChange={onInputchange}
                            name="message"
                            required
                          >
                          </textarea>
                        </div>

                        <div className="mt-0 pt-0 small white-text">* Need to fill marked. Make a call more details required.</div>
                        <button type="submit" className="btn-white-custom btn btn-sm mt-3"> Send Message </button>
                      </div>
                    </div>
                  </form>
                </section>
              </section>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </Layout>
  );
};

export default IotDevelopment;
